import { h } from 'preact'; /** @jsx h */

import GiftForm from '../../../../forms/GiftForm';

import './SplitCTABox.scss';

const renderFromDone = id => {
    if (window.location.hash === '#' + id) {
        const elemtentWithForm = document.querySelector('#' + id);

        elemtentWithForm.scrollIntoView();
    }
};

const SplitCTABox = ({ color = 'secondary' }) => {
    return (
        <div className={`split-cta-box color-${color}`}>
            <a
                className="box left-box"
                href="/nettbutikk/symbolske-gaver/et-hjerte-som-banker-igjen/"
                target="_blank"
            >
                <div>
                    <h2>Et hjerte som banker igjen</h2>
                </div>
                <div className="btn-container">
                    <span className="btn btn-primary">
                        Kjøp den symbolske gaven her
                        {/* <span className="material-symbols-outlined">open_in_new</span> */}
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29 25">
                            <path
                                d="M26.27,2.68a7.72,7.72,0,0,0-10.75,0l-1,1-1-1a7.73,7.73,0,0,0-10.75,0,7.33,7.33,0,0,0,0,10.53L14.15,24.36a.51.51,0,0,0,.7,0L26.27,13.21a7.33,7.33,0,0,0,0-10.53Z"
                                fill="#fff"
                            />
                        </svg>
                    </span>
                </div>
            </a>
            <div className="divider">eller</div>
            <div className="box right-box">
                <div className="form-wrapper supportus-form-wrapper">
                    <GiftForm
                        id="gift-form-999"
                        level={2}
                        renderCb={renderFromDone}
                        titleStep1="Gi en julegave"
                        infoTxtStep1="Støtt årets juleaksjon"
                        options={[
                            {
                                value: 250,
                                label: '250'
                            },
                            {
                                value: 300,
                                label: '300'
                            },
                            {
                                value: 400,
                                label: '400'
                            },
                            {
                                value: 500,
                                label: '500'
                            }
                        ]}
                    />
                </div>
            </div>
        </div>
    );
};

export default SplitCTABox;
